import { render, staticRenderFns } from "./add-task.vue?vue&type=template&id=06f4acd8"
import script from "./add-task.vue?vue&type=script&lang=js"
export * from "./add-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports